import * as XLSX from 'xlsx';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class ExcelLogsDownloadService {

  constructor() { }

  // exportToExcel(data: any[], fileName: string): void {
  //   // Create a worksheet
  //   console.log(data)
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

  //   // Create a workbook
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: { 'Sheet1': worksheet },
  //     SheetNames: ['Sheet1'],
  //   };

  //   // Write the workbook as a binary string
  //   const excelBuffer: any = XLSX.write(workbook, {
  //     bookType: 'xlsx',
  //     type: 'array',
  //   });

  //   // Save the file
  //   this.saveAsExcelFile(excelBuffer, fileName);
  // }


  exportToExcel(data: any[], fileName: string): void {
    const flattenedData = data.map((obj) => [obj.key, obj.value]);
  
    console.log(flattenedData);
  
    // Create a worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(flattenedData);
  
    // Create a workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Sheet1': worksheet },
      SheetNames: ['Sheet1'],
    };
  
    // Write the workbook as a binary string
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
  
    // Save the file
    this.saveAsExcelFile(excelBuffer, fileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(data, `${fileName}.xlsx`);
  }
  
}

